import { z } from "zod";

export const mirrorFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    mirrorElement: z.string(),
});

export type MirrorFormData = z.infer<typeof mirrorFormSchema>;
